import { createSelector } from "@reduxjs/toolkit";
import { RootState } from "../store/types";

// Root selectors

const getConnectState = (state: RootState) => state.connect;

// Connect Selectors
export const getConnectDatasetsSelector = createSelector(
  [getConnectState],
  (connect) => connect?.datasets,
);

export const getConnectStatusSelector = createSelector(
  [getConnectState],
  (connect) => connect?.status,
);

export const getConnectLoadingIndicatorSelector = createSelector(
  [getConnectState],
  (connect) => connect?.showLoadingIndicator,
);

export const getConnectErrorMessageSelector = createSelector(
  [getConnectState],
  (connect) => connect?.errorMessage,
);

export const getConnectDatasetForApi = (apiName: string) =>
  createSelector(getConnectState, (connect) => connect?.datasets[apiName]);
